import React from 'react';
import './About.css';
function About() {
  return (
    <div className='about' >
        <h1>About US</h1>
        <p>
        IEEE is the world's largest professional association dedicated to advancing technological
innovation and excellence for the benefit of humanity. IEEE and its members inspire a global
community through IEEE's highly cited publications, conferences, technology standards, and
professional and educational activities.
        </p>
        <h1>IEEE Student Branch Vadapalani</h1>
        <p>
        IEEE is the world's largest professional association dedicated to advancing technological
innovation and excellence for the benefit of humanity. IEEE and its members inspire a global
community through IEEE's highly cited publications, conferences, technology standards, and
professional and educational activities.
        </p>
    </div>
  )
}

export default About